import { AlertTriangle } from "lucide-react";

/* Styled confirmation dialog — replaces window.confirm across the app. */
export const ConfirmDialog = ({ open, title, message, confirmLabel = "Confirm", tone = "primary",
  busy = false, onConfirm, onCancel, testid = "confirm-dialog" }) => {
  if (!open) return null;
  const danger = tone === "danger";
  const color = danger ? "#EA4335" : "#4285F4";
  return (
    <div className="fixed inset-0 z-[150] bg-black/50 backdrop-blur-[2px] flex items-center justify-center p-4"
      onMouseDown={(e) => { if (e.target === e.currentTarget && !busy) onCancel(); }} data-testid={testid}>
      <div className="bg-white border border-zinc-200 w-full max-w-md shadow-2xl">
        <div className="h-1" style={{ background: color }} />
        <div className="p-5">
          <h3 className="font-heading font-900 text-lg flex items-center gap-2" style={{ color }}>
            {danger && <AlertTriangle className="w-5 h-5" />} {title}
          </h3>
          <p className="text-sm text-zinc-700 mt-2 whitespace-pre-line">{message}</p>
          <div className="flex justify-end gap-2 mt-5">
            <button onClick={onCancel} disabled={busy} data-testid={`${testid}-cancel`}
              className="px-4 py-2 border border-zinc-300 text-sm font-600 hover:bg-zinc-50 disabled:opacity-50">
              Cancel
            </button>
            <button onClick={onConfirm} disabled={busy} data-testid={`${testid}-confirm`}
              className="px-5 py-2 text-white text-sm font-700 hover:opacity-90 transition-opacity disabled:opacity-50"
              style={{ background: color }}>
              {busy ? "Working…" : confirmLabel}
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};
